import { useMemo, useState } from "react";

import { type Member } from "../../molecules/MemberCard/types";

export const useMembersSlideout = (members: Member[], requests: Member[]) => {
  const [searchQuery, setSearchQuery] = useState("");

  const totalMembers = members.length + requests.length;

  // Filter members and requests based on search query
  const filteredMembers = useMemo(() => {
    if (!searchQuery.trim()) {
      return members;
    }

    const query = searchQuery.toLowerCase();
    return members.filter((member) => {
      const fullName = `${member.firstName || ""} ${member.lastName || ""}`.toLowerCase();
      const email = (member.email || "").toLowerCase();
      const roles = member.roles.join(" ").toLowerCase();

      return fullName.includes(query) || email.includes(query) || roles.includes(query);
    });
  }, [members, searchQuery]);

  const filteredRequests = useMemo(() => {
    if (!searchQuery.trim()) {
      return requests;
    }

    const query = searchQuery.toLowerCase();
    return requests.filter((request) => {
      const fullName = `${request.firstName || ""} ${request.lastName || ""}`.toLowerCase();
      const email = (request.email || "").toLowerCase();
      const roles = request.roles.join(" ").toLowerCase();

      return fullName.includes(query) || email.includes(query) || roles.includes(query);
    });
  }, [requests, searchQuery]);

  const facilitators = useMemo(() => filteredMembers.filter((m) => m.isFacilitator), [filteredMembers]);
  const regularMembers = useMemo(() => filteredMembers.filter((m) => !m.isFacilitator), [filteredMembers]);

  return {
    facilitators,
    filteredMembers,
    filteredRequests,
    regularMembers,
    searchQuery,
    setSearchQuery,
    totalMembers,
  };
};
